export default "__VITE_ASSET__D8zM$YGC__"